<template>
    <div class='overview'>
        <section class="stats columns has-text-centered">
            <div class="column">
                <article class="card">
                    <div class="card-content">
                        <p class="title">
                            {{ stats.students }}
                            <b-icon v-if="stats.students === null" icon="loading" custom-class="mdi-spin" />
                        </p>

                        <p class="subtitle">Studerende</p>
                    </div>
                </article>
            </div>

            <div class="column">
                <article class="card">
                    <div class="card-content">
                        <p class="title">
                            {{ stats.customers }}
                            <b-icon v-if="stats.customers === null" icon="loading" custom-class="mdi-spin" />
                        </p>

                        <p class="subtitle">Kunder</p>
                    </div>
                </article>
            </div>

            <div class="column">
                <article class="card">
                    <div class="card-content">
                        <p class="title">
                            {{ stats.openProjects }}
                            <b-icon v-if="stats.openProjects === null" icon="loading" custom-class="mdi-spin" />
                        </p>

                        <p class="subtitle">Åbne projekter</p>
                    </div>
                </article>
            </div>

            <div class="column">
                <article class="card">
                    <div class="card-content">
                        <p class="title" v-if="stats.projectValue !== null">{{ stats.projectValue }} kr.</p>
                        <p class="title" v-else>
                            <b-icon icon="loading" custom-class="mdi-spin" />
                        </p>

                        <p class="subtitle">Projekt-værdi</p>
                    </div>
                </article>
            </div>
        </section>

        <section class="columns">
            <div class="column">
                <div class="card">
                    <header class="card-header">
                        <div class="card-header-title">
                            <b-icon icon="chart-line" />
                            &nbsp;
                            <span>Udvikling i antal</span>
                        </div>
                    </header>

                    <div class="card-content">
                        <overview-chart :period="period" :from="from" :to="to" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss" scoped>
    .administration {
        background: #F5F7FA;
    }
</style>

<script>
    import StudentService from '@/taskflex/students/services/StudentService';
    import CustomerService from '@/taskflex/customers/services/CustomerService';
    import ProjectService from '@/taskflex/projects/services/ProjectService';
    import OverviewChart from '@/taskflex/administration/components/OverviewChart';

    const moment = require('moment');

    export default {
        data() {
            return {
                stats: {
                    students: null,
                    customers: null,
                    openProjects: null,
                    projectValue: null,
                },

                period: 'day',
                from: moment().startOf('month').format('DD-MM-YYYY'),
                to: moment().endOf('month').format('DD-MM-YYYY'),
            };
        },

        mounted() {
            this.loadStats();
        },

        methods: {
            loadStats() {
                // Students
                StudentService.count({}, ({ data }) => {
                    this.stats.students = data.count;
                });

                // Customers
                CustomerService.count({}, ({ data }) => {
                    this.stats.customers = data.count;
                });

                // Open Projects & Value
                const options = {
                    filter_groups: [
                        {
                            filters: [
                                {
                                    key: 'status',
                                    operator: 'in',
                                    value: ['project-created', 'project-accepted', 'project-clarification'],
                                },
                            ],
                        },
                    ],
                };

                ProjectService.count(options, ({ data }) => {
                    this.stats.openProjects = data.count;
                });

                ProjectService.value(options, ({ data }) => {
                    this.stats.projectValue = data.value;
                });
            },
        },

        components: {
            OverviewChart,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/pages/Statistics.vue